<template>
  <div class="row servicesdetail">
    <div class="col-md-6 col-12">
      <img src="https://cdn.proxyscrape.com/img/service_icons-02.svg?v=3" alt="" />
    </div>
    <div class="col-md-6 col-12 d-flex align-items-center">
      <div>
        <h2><span class="proxynumber">40k+</span><br />Datacenter proxy pool</h2>
        <p>
          Thanks to the enormous growth, ProxyScrape can host its own dedicated proxy pool. By
          pooling its customers together, we make sure you get
          <strong>the best datacenter proxies with Socks5 & HTTP support</strong> at an affordable
          price.
        </p>
        <div class="row">
          <div class="col-xl-5 col-12">
            <router-link class="btn w-100" to="/premium?ref=buy-socks5-proxy"
              >Learn more</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12 d-md-none d-block">
      <img src="https://cdn.proxyscrape.com/img/service_icons-03.svg?v=3" alt="" />
    </div>
    <div class="col-md-6 col-12 d-flex align-items-center">
      <div>
        <h2>Dedicated proxies</h2>
        <p>
          Socks5 proxies that are only used by you with an internet speed of 1GBPs and unlimited
          bandwidth. Do you need proxies that you only use to ensure the best possible quality? Then
          dedicated proxies is the best choice!
        </p>
        <div class="row">
          <div class="col-xl-5 col-12">
            <router-link class="btn w-100" to="/dedicated?ref=buy-socks5-proxy"
              >Learn more</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12 d-md-block d-none">
      <img src="https://cdn.proxyscrape.com/img/service_icons-03.svg?v=3" alt="" />
    </div>
  </div>
</template>
